import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'extended-hours-dialog',
    templateUrl: 'extended-hours-dialog.component.html',
    styleUrls: ['./extended-hours-dialog.component.css']
})
export class ExtendedHoursDialog {
    constructor(
        public dialogRef: MatDialogRef<ExtendedHoursDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        // console.log(data.tradingEntitlements.isRetailUser);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    scrollToElement($element): void {
        console.log($element);
        $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
      }

}
